import { useState,useEffect,useContext } from 'react'
import Slider from 'react-slick'
import { Box,Grid,List,ListItemButton,ListItemIcon,ListItemText,TextField,Typography,Modal,Fade, Alert, Tooltip, Divider } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { get, post } from '../../utils/axios'
import Button from '../../components/Button'
import { CheckCircleOutline } from '@mui/icons-material'
import { toast } from 'react-toastify'
import { Context } from '../../context/Context'
import { updateLocalTicketsData } from '../../utils'
import axios from 'axios'

import './Home.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Home = () => {

    const context = useContext(Context)
    const navigate = useNavigate()

    const [gatewayId,setGatewayId] = useState(0)
    const [guilds,setGuilds] = useState([])
    const [gateways,setGateways] = useState([])
    const [open,setOpen] = useState(false)
    const [openDeposit,setOpenDeposit] = useState(false)
    const [isLoading,setIsLoading] = useState(false)
    const [amount,setAmount] = useState('')
    const [currentMessage,setCurrentMessage] = useState('')
    const [currentTitle,setCurrentTitle] = useState('')
    const [notifications,setNotifications] = useState([])
    const [ads,setAds] = useState([])
    const [favorits,setFavorits] = useState([])
    const [sliderRef,setSliderRef] = useState({})
    const [cards,setCards] = useState({cards: [],cardNumber: '',balance: ''})
    const [showCards,setShowCards] = useState(true)
    const [restaurantIndex,setRestaurantIndex] = useState(-1)
    const [cardsTitle,setCardsTitle] = useState([])
    const [version,setVersion] = useState({})
    const [ticketsCount,setTicketsCount] = useState(0)
    const [openLastVersionInfo,setOpenLastVersionInfo] = useState(false)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    }

    const versionStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '92%',
        maxHeight: '94dvh',
        boxSizing: 'border-box',
        bgcolor: 'background.paper',
        overflowY: 'auto',
        boxShadow: 24,
        p: 4,
    }

    useEffect(() => {
        axios.get('https://petromah.sabinarya.com/service/api/Info/getVersions').then(({ data }) => {
            if(data.status)
                setVersion(data.result.length ? data.result[data.result.length - 1] : {})
        })
        get('Anoncement/GetAnoncement').then(({ data }) => {
            if(data.isSuccess)
                setNotifications(data.data)
        })
        post('Payment/GetActiveGateway').then(({ data }) => {
            if(data.isSuccess){
                setGateways(data.data)
                setGatewayId(data.data[0].id)
            }
        })
        post('Advertisement/GetAllAdvertisement').then(({ data }) => {
            if(data.isSuccess)
                setAds(data.data)
        })
        post('Anoncement/GetFavoriteAnoncement').then(({ data }) => {
            if(data.isSuccess)
                setFavorits(data.data.id)
        })
        updateLocalTicketsData().then(cnt => setTicketsCount(cnt))
    },[])

    useEffect(() => {
        setGuilds(context.guilds)
    },[context.guilds])

    useEffect(() => {
        setCards(context.cards)
    },[context.cards])

    useEffect(() => {
        setShowCards(context.showCards)
    },[context.showCards])

    useEffect(() => {
        setCardsTitle(context.cardsTitle)
    },[context.cardsTitle])

    useEffect(() => {
        setRestaurantIndex(context.restaurantIndex)
    },[context.restaurantIndex])

    useEffect(() => {
        if(sliderRef && restaurantIndex != -1 && Object.keys(sliderRef).length)
            sliderRef.slickGoTo(restaurantIndex)
    },[sliderRef,restaurantIndex])

    useEffect(() => {
        if(Object.keys(version).length){
            if(localStorage.getItem(version.versionId) != 1)
                setOpenLastVersionInfo(true)
        }
    },[version])
    
    const settings = {
        centerMode: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '10px',
        className: 'center',
        initialSlide: -1,
        rtl: true
    }
    
    const adsSettings = {
        autoplay: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        rtl: true
    }
    
    const openPage = guildId => {
        navigate(`/app/businesses/${guildId}`)
    }
    
    const openNotificationModal = notification => {
        setCurrentTitle(notification.title)
        setCurrentMessage(notification.content)
        setOpen(true)
    }
    
    const setAmountValue = value => {
        value = value.toString().replace(/,/g,'')
        value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value)
        if(value == 'NaN')
            value = '';
        setAmount(value)
    }

    const chargeDeposit = () => {
        setIsLoading(true)
        const postedData = {
            amount: amount.toString().replace(/,/g,''),
            gatewayId,
            action: 1
        }
        post('Payment/GetToken',postedData).then(({ data }) => {
            if(data.isSuccess)
                window.location.href = data.data.redirectUrl
            else
                setIsLoading(false)
        }).catch((e) => {
            setIsLoading(false)
        })
    }

    const shareNotification = notification => {
        if(navigator.share)
            navigator.share({
                title: notification.title,
                text: notification.title + '\r\n' + notification.content
            })
        else
            toast.warning('این عملیات فقط در موبایل امکان پذیر است')
    }

    const addToFavorite = notification => {
        const postedData = {
            id: notification.id
        }
        post('Anoncement/AddFavoriteAnoncement',postedData).then(({ data }) => {
            if(data.isSuccess){
                setFavorits(data.data.id)
                toast.success('به لیست علاقه مندی ها افزوده شد')
            }
        })
    }

    const removeFromFavorite = notification => {
        const postedData = {
            id: notification.id
        }
        post('Anoncement/RemoveFavoriteAnoncement',postedData).then(({ data }) => {
            if(data.isSuccess){
                setFavorits(data.data.id)
                toast.success('از لیست علاقه مندی ها حذف شد')
            }
        })
    }

    const updateCardsData = e => {
        e.stopPropagation()
        setCards(() => ({cards: [],cardNumber: '',balance: ''}))
        context.updateCardData()
    }

    const confirmUpdate = () => {
        localStorage.setItem(version.versionId,'1')
        setOpenLastVersionInfo(false)
    }
    
    return (
        <div id="home">
            <div className="safe-area">
                {showCards ? (cards.cards && cards.cards.length ? (context.profile.roleId != 103 ? <Slider {...settings} ref={slider => setSliderRef(slider)}>
                    {/* <div className="card-item segment-card-item">
                        <img src="/assets/img/petro-card-segment.jpg" className="bg-card" />
                        <div className="deposit-box">
                            <span className="deposit-value">{cards.balance}<span className="deposit-currency">(ریال)</span></span>
                            <span className="deposit-title">موجودی شما</span>
                        </div>
                        <span className="card-number">{cards.cardNumber}</span>
                        <span className="card-title">کیف پول نقدی</span>
                        <button onClick={() => setOpenDeposit(true)} className="deposit-wallet-anker">افزایش موجودی</button>
                    </div> */}
                    {cards.cards.filter(card => cardsTitle.find(c => c.value == card.segmentHash)?.status).map(card => <div key={card.id} className={`card-item ${!cardsTitle.find(c => c.value == card.segmentHash)?.status ? 'card-disable' : ''}`} onClick={() => !cardsTitle.find(c => c.value == card.segmentHash)?.status ? false : navigate(context.profile.roleId != 103 ? `reports/transactions/${card.segmentHash}` : 'reports/child-transactions')}>
                        <img src="/assets/img/petro-card.jpg" className="bg-card" />
                        {false && <span className="card-status">فعال</span>}
                        <div className="deposit-box">
                            <span className="deposit-value"><span className="deposit-currency">(ریال)</span>{card.balance}</span>
                            <span className="deposit-title">موجودی شما</span>
                        </div>
                        <span className="card-number">{cards.cardNumber}</span>
                        <span className="card-exp">{cards.exp}</span>
                        <span className="card-title">{cardsTitle.find(c => c.value == card.segmentHash)?.title}</span>
                        <Tooltip title="به روزرسانی موجودی"><i className="far fa-rotate-left handle-refresh-cards-btn" onClick={e => updateCardsData(e)}></i></Tooltip>
                        {!cardsTitle.find(c => c.value == card.segmentHash)?.status ? <p className="card-disable-text">این کارت غیرفعال است و امکان استفاده از این کارت را ندارید</p> : ''}
                    </div>)}
                </Slider> : <Slider {...settings} ref={slider => setSliderRef(slider)}>
                    {cards.cards.filter(card => cardsTitle.find(c => c.value == card.segmentHash)?.status).map(card => <div key={card.id} className={`card-item ${!cardsTitle.find(c => c.value == card.segmentHash)?.status ? 'card-disable' : ''}`} onClick={() => !cardsTitle.find(c => c.value == card.segmentHash)?.status ? false : navigate(context.profile.roleId != 103 ? `reports/transactions/${card.segmentHash}` : 'reports/child-transactions')}>
                        <img src="/assets/img/petro-card.jpg" className="bg-card" />
                        {false && <span className="card-status">فعال</span>}
                        <div className="deposit-box">
                            <span className="deposit-value">{card.balance}<span className="deposit-currency">(ریال)</span></span>
                            <span className="deposit-title">میزان قابل استفاده فعلی</span>
                        </div>
                        <span className="card-number">{cards.cardNumber}</span>
                        <span className="card-title">{cardsTitle.find(c => c.value == card.segmentHash)?.title}</span>
                        <Tooltip title="به روزرسانی موجودی"><i className="far fa-rotate-left handle-refresh-cards-btn" onClick={e => updateCardsData(e)}></i></Tooltip>
                        {!cardsTitle.find(c => c.value == card.segmentHash)?.status ? <p className="card-disable-text">این کارت غیرفعال است و امکان استفاده از این کارت را ندارید</p> : ''}
                    </div>)}
                </Slider>) : 
                <div id="slider-placeholder" className="card-item">
                    <img src="/assets/img/petro-card.jpg" className="bg-card" />
                    <div className="deposit-box deposit-box-placeholder animate"></div>
                    <span className="card-number card-number-placeholder animate"></span>
                    <span className="card-title card-title-placeholder animate"></span>
                    <button className="deposit-wallet-anker deposit-wallet-anker-placeholder animate"></button>
                </div>
                ): ''}
                <Modal open={openDeposit} onClose={() => setOpenDeposit(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Fade in={openDeposit}>
                        <Box sx={style}>
                            <Typography variant="h6" component="h2" sx={{ fontSize: 18 }}>افزایش موجودی</Typography>
                            <TextField type="tel" className="ltr-input" sx={{mb: 3,mt: 2}} fullWidth={true} inputProps={{maxLength: 12}} label="مبلغ" variant="standard" value={amount} onChange={e => setAmountValue(e.target.value)} />
                            <Typography variant="subtitle2" component="span" className="choose-gateway-title">انتخاب درگاه پرداخت</Typography>
                            <List component="nav">
                                {gateways.map((gateway,index) => <ListItemButton key={gateway.id} selected={index == 0} onClick={() => setGatewayId(gateway.id)}>
                                    <img src={gateway.logo} width={60} style={{ marginLeft: 10 }} />
                                    <ListItemText>{gateway.title}</ListItemText>
                                    {gatewayId == gateway.id ? <ListItemIcon sx={{ minWidth: 'unset' }}>
                                        <CheckCircleOutline color="success" />
                                    </ListItemIcon> : ''}
                                </ListItemButton>)}
                            </List>
                            <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 1,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!amount || amount.length < 6 || amount.replace(/,/g,'') < 10000} onClick={chargeDeposit}>پرداخت و افزایش موجودی</Button>
                        </Box>
                    </Fade>
                </Modal>
                <Modal open={openLastVersionInfo} onClose={() => setOpenLastVersionInfo(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Fade in={openLastVersionInfo}>
                        {Object.keys(version).length ? <Box sx={{...versionStyle,pb: 3}}>
                            <i className="fal fa-x close-modal-btn" onClick={() => setOpenLastVersionInfo(false)}></i>
                            <Typography variant="h6" component="h2" sx={{ mb: 1,fontSize: 18 }}>تغییرات آخرین نسخه</Typography>
                            <Divider sx={{mb: 2.5,mt: 2}} />
                            <ul className="version-details">
                                {version.version_Info.split('-').map((i,index) => {
                                    if(i)
                                        return <li style={{fontSize: 14}} key={`list-${index}`}>{i}</li>
                                })}
                            </ul>
                            <Button fullWidth={true} sx={{mt: 3,py: 1.5}} variant="contained" onClick={confirmUpdate}>متوجه شدم</Button>
                        </Box> : ''}
                    </Fade>
                </Modal>
                <div id="our-services">
                    <h2>خدمات ما</h2>
                    <Grid container spacing={1.5} id="our-services-container">
                        {/* <Grid item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(43)}>
                                <img className="button-icon" src="/assets/img/icons/services/sport.png" />
                                <span className="button-text">ورزشی</span>
                            </button>
                        </Grid>
                        <Grid item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(64)}>
                                <img className="button-icon" src="/assets/img/icons/services/food.png" />
                                <span className="button-text">رستوران</span>
                            </button>
                        </Grid>
                        <Grid item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(63)}>
                                <img className="button-icon" src="/assets/img/icons/services/cultural.png" />
                                <span className="button-text">فرهنگی آموزشی</span>
                            </button>
                        </Grid>
                        <Grid item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(165)}>
                                <img className="button-icon" src="/assets/img/icons/services/it.png" />
                                <span className="button-text">اینترنت</span>
                            </button>
                        </Grid>
                        <Grid item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(144)}>
                                <img className="button-icon" src="/assets/img/icons/services/hotels.png" />
                                <span className="button-text">هتل و اقامتگاه</span>
                            </button>
                        </Grid>
                        <Grid item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(204)}>
                                <img className="button-icon" src="/assets/img/icons/services/online-shop.png" />
                                <span className="button-text">فروش آنلاین</span>
                            </button>
                        </Grid> */}
                        {guilds.map(guild => <Grid key={guild.id} item xs={3.8} mb={0.5}>
                            <button className="service-button" onClick={() => openPage(guild.id)}>
                                <img className="button-icon" src={`https://petromah.sabinarya.com${guild.iconPath}`} />
                                <span className="button-text">{guild.title}</span>
                            </button>
                        </Grid>)}
                    </Grid>
                    <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                            <button className="reports-button" onClick={() => navigate(context.profile.roleId != 103 ? '/app/reports/transactions' : '/app/reports/child-transactions')}><i className="fal fa-chart-simple"></i>سوابق تراکنش</button>
                        </Grid>
                        {context.profile.roleId != 103 ? <Grid item xs={6}>
                            <button className="other-button" onClick={() => navigate('/app/children')}><i className="fal fa-users"></i>شریک من</button>
                        </Grid> : <Grid item xs={6}>
                            <button className="other-button" onClick={() => navigate('/app/segments')}><i className="fal fa-credit-card"></i>منابع مالی من</button>
                        </Grid>}
                        <Grid item xs={12}>
                            <button className="support-button" onClick={() => navigate('/app/tickets')}><i className="fal fa-headset"></i>درخواست های پشتیبانی و شکایات <span>{ticketsCount}</span></button>
                        </Grid>
                    </Grid>
                </div>
                <div id="ads-slider">
                    <Slider {...adsSettings}>
                        {ads.map(adsItem => <a href={adsItem.url} className="ads-slider-item" key={adsItem.id}><img src={`${!adsItem.image.includes('data:image') ? 'data:image/jpeg;base64,' : ''}${adsItem.image}`} alt={adsItem.title} /></a>)}
                    </Slider>
                </div>
                <div id="notifications">
                    <h2>اطلاعیه ها<span className="show-favorite-notifications" onClick={() => navigate('/app/others/favorites')}>مشاهده علاقه مندی ها</span></h2>
                    <div id="notification-box">
                        {notifications.length ? notifications.map(notification => <div key={notification.id} className="notification-content" onDoubleClick={() => addToFavorite(notification)}>
                            <h3><i className="fal fa-pen"></i>{notification.title}</h3>
                            <Tooltip title="اشتراک گذاری"><i className="fal fa-share-nodes share-notification-button" onClick={() => shareNotification(notification)}></i></Tooltip>
                            {!favorits.includes(notification.id) ? <Tooltip title="پسندیدن"><i className="fal fa-heart add-to-favorite-notification-button" onClick={() => addToFavorite(notification)}></i></Tooltip> : <Tooltip title="نپسندیدن"><i className="fas fa-heart add-to-favorite-notification-button" onClick={() => removeFromFavorite(notification)}></i></Tooltip>}
                            <p>{notification.content.slice(0,70)} ...</p>
                            <button className="read-notification" onClick={() => openNotificationModal(notification)}>ادامه خواندن</button>
                        </div>) : <Alert variant="standard" color="info">فعلاً هیچ اطلاعیه جدیدی برای مشاهده ندارید</Alert>}
                        <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <Fade in={open}>
                                <Box sx={style}>
                                    <Typography variant="h6" component="h2">{currentTitle}</Typography>
                                    <Typography sx={{ mt: 2,textAlign: 'justify' }}>{currentMessage}</Typography>
                                </Box>
                            </Fade>
                        </Modal>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home